/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Donate = {
    readonly bottomSectionTitle: string;
    readonly bottomSectionSubtitle: string | null;
    readonly bottomSectionText: string | null;
    readonly bottomSectionSidePicture: string | null;
    readonly bottomSectionHide: boolean;
    readonly donateUrl: string | null;
    readonly " $refType": "Donate";
};
export type Donate$data = Donate;
export type Donate$key = {
    readonly " $data"?: Donate$data;
    readonly " $fragmentRefs": FragmentRefs<"Donate">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Donate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomSectionTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomSectionSubtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomSectionText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomSectionSidePicture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomSectionHide",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "donateUrl",
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = '61de38dce25a548ce4331abd17e6016c';
export default node;
